


import * as THREE from 'three';

const DEFAULT_LAYER = 0;
const GROUND_LAYER = 1;
const BASE_MODULE_LAYER = 2;
const TOP_MODULE_LAYER = 4;
const ACCESSORY_MODULE_LAYER = 5;
const MODULE_LAYER = 6;
const SNAPPOINT_LAYER = 7;
const FLOOR_LAYER = 8;

const DEBUG_LAYER = 13;

//Important: > 0
const GRID_SNAP_SIZE = new THREE.Vector3(0.1,0.1,0.1)
const SNAP_POINT_RADIUS = 0.1;//m

const Y_POSITIVE = new THREE.Vector3(0,1,0)

const MAX_CLICK_DURATION = 250;//ms

export {
    DEFAULT_LAYER,
    GROUND_LAYER, 
    BASE_MODULE_LAYER,
    TOP_MODULE_LAYER,
    ACCESSORY_MODULE_LAYER,
    SNAPPOINT_LAYER,
    MODULE_LAYER,
    DEBUG_LAYER,
    GRID_SNAP_SIZE,
    SNAP_POINT_RADIUS,
    Y_POSITIVE,
    MAX_CLICK_DURATION,
    FLOOR_LAYER
}